// extracted by mini-css-extract-plugin
export default {"component":"Vq3Xoy6M","arrow":"GA557WPn","container":"h2oDJBBB","tooltip":"mwOr_f0u","label":"awTAK0Zn","svg":"OYNdWFby","top":"p9ikQFsw","text":"YF8x6z64"};